import { doc, setDoc, deleteDoc, increment, updateDoc, collection, getDoc } from "firebase/firestore";

/**
 * Toggles an action (like or favorite) for a specific tribute.
 *
 * @param {object} db - Firestore database instance.
 * @param {string} tributeId - The ID of the tribute.
 * @param {string} actionType - The type of action (e.g., "liked", "favorite").
 * @param {string} userId - The ID of the user performing the action.
 * @param {object} currentState - Current state of the action (like or favorite).
 * @param {function} stateSetter - Function to update the state in UI.
 */
export const toggleAction = async (db, tributeId, actionType, userId, currentState, stateSetter) => {
  try {
    const actionRef = doc(db, `memorials/${tributeId}/${actionType}/${userId}`);
    const tributeRef = doc(db, `memorials/${tributeId}`);
    const isActionTaken = currentState?.[tributeId];

    if (isActionTaken) {
      // Undo the action (unlike/unfavorite)
      await deleteDoc(actionRef);
      await updateDoc(tributeRef, {
        [`${actionType}Count`]: increment(-1),
      });
      stateSetter((prev) => ({ ...prev, [tributeId]: false }));
    } else {
      // Perform the action (like/favorite)
      await setDoc(actionRef, {
        action: actionType === "liked" ? "Like" : "Favorite",
        timestamp: new Date(),
      });
      await updateDoc(tributeRef, {
        [`${actionType}Count`]: increment(1),
      });
      stateSetter((prev) => ({ ...prev, [tributeId]: true }));
    }
  } catch (error) {
    console.error(`Error toggling ${actionType} action:`, error);
  }
};



export function memorialColors(occasion) {
  switch (occasion) {
      case "Memorial": 
          return "primary"
      case "Birthday & Celebration": 
          return "success"
      case "Congrats & Praise": 
          return "warning"
      case "Farewell": 
          return "secondary"
      case "Sympathy & Get Well": 
          return "info"
      case "Thank You": 
          return "dark"
      case "Welcome": 
          return "dark"
      case "Service Anniversary": 
          return "light"
      case "Event": 
          return "danger"
  }
}

  